import { createSlice } from "@reduxjs/toolkit";
import { generateReport } from "./MerchantPeriodicReport.thunk";

const baseState = {
  status: "idle",
  error: null,
  retryCount: 0,
  merchantData: null,
  merchantHolding: null,
  consolidatedData: null,
  currency: null,
};

const initialState = {
  ...baseState,
};

export const merchantPeriodicReportSlice = createSlice({
  name: "merchantPeriodicReport",
  initialState,
  reducers: {
    ResetStore: (state) => {
      return { ...baseState };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(generateReport.pending, (state) => {
        state.status = "loading";
      })
      .addCase(generateReport.fulfilled, (state, action) => {
        const {
          retryCount,
          merchantData,
          merchantHolding,
          consolidatedData,
          currency,
        } = action.payload;
        state.retryCount = retryCount;
        state.merchantData = merchantData;
        state.merchantHolding = merchantHolding;
        state.consolidatedData = consolidatedData;
        state.currency = currency ?? state.currency;
        state.status = "succeeded";
        state.error = null;
      })
      .addCase(generateReport.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload?.message || "Error generating report";
      });
  },
});

export const { ResetStore } = merchantPeriodicReportSlice.actions;

export default merchantPeriodicReportSlice.reducer;
